// extracted by mini-css-extract-plugin
module.exports = {"title":"horizontalTitle-module--title--38Avj","subtitle":"horizontalTitle-module--subtitle--21sMs"};